module.exports = __webpack_public_path__ + "img/excel.6d93c6b6.svg";